export default __webpack_public_path__ + "static/js-d4bba60245e59b9626f01883908c8154.svg";